var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPdfSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45275 1C7.45275 0.585786 7.78854 0.25 8.20275 0.25H11.8027C12.217 0.25 12.5527 0.585786 12.5527 1V5.91667H14.2028C14.5009 5.91667 14.7707 6.09327 14.8901 6.36649C15.0094 6.63972 14.9555 6.95768 14.7529 7.17638L10.5529 11.7097C10.411 11.8629 10.2116 11.95 10.0027 11.95C9.7939 11.95 9.59452 11.8629 9.45258 11.7097L5.25258 7.17638C5.04995 6.95768 4.99611 6.63972 5.11544 6.36649C5.23477 6.09327 5.5046 5.91667 5.80275 5.91667H7.45275V1Z",
    fill: "#767B87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2 1.75C1.91085 1.75 1.75 1.96176 1.75 2.13333V16.8667C1.75 17.0382 1.91085 17.25 2.2 17.25H17.8C18.0892 17.25 18.25 17.0382 18.25 16.8667V2.13333C18.25 1.96176 18.0892 1.75 17.8 1.75H15.4C14.9858 1.75 14.65 1.41421 14.65 1C14.65 0.585786 14.9858 0.25 15.4 0.25H17.8C18.8356 0.25 19.75 1.05371 19.75 2.13333V16.8667C19.75 17.9463 18.8356 18.75 17.8 18.75H2.2C1.16435 18.75 0.25 17.9463 0.25 16.8667V2.13333C0.25 1.05371 1.16435 0.25 2.2 0.25H4.6C5.01421 0.25 5.35 0.585786 5.35 1C5.35 1.41421 5.01421 1.75 4.6 1.75H2.2Z",
    fill: "#767B87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16C1 14.8954 1.30996 14 1.69231 14H18.3077C18.69 14 19 14.8954 19 16C19 17.1046 18.69 18 18.3077 18H1.69231C1.30996 18 1 17.1046 1 16Z",
    fill: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfSolid);
export default __webpack_public_path__ + "static/media/download_pdf_solid.abe1fe4ece7884d1b0d74ea0657ec7d5.svg";
export { ForwardRef as ReactComponent };